module.exports = "<p>\r\n  consulterhistcarte works!\r\n</p>\r\n"